import React, { useRef, useState, useEffect } from 'react'
import classnames from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import SwiperButton from 'Components/swiper-button'
import Link from 'next/link'
import { IPageConfig } from './popular-model'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image } from 'Components/view-image'

SwiperCore.use([Navigation])
interface IProps {
  hotBrand: any
  responsiveType: any
  nav: any
}

// 品牌分类配置
const Brand_MAX = 32
export const brandPageConfig: IPageConfig = {
  sm: {
    size: 7,
    page: 5,
  },
  md: {
    size: 9,
    page: 4,
  },
  lg: {
    size: 9,
    page: 4,
  },
  xl: {
    size: 13,
    page: 3,
  },
  '2xl': {
    size: 16,
    page: 2,
  },
}

export function renderBrandItem(item: any, index: number) {
  return (
    <div className="series model" key={`hot-brand-${index}`}>
      <Link
        href={`/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${item.brand_id}&text=${item.brand_name}`}
        as={`/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${item.brand_id}&text=${item.brand_name}`}
      >
        <a
          target="_blank"
          title={item.brand_name}
          className="brand-wrap"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'select_module_brand_cell',
              brand_id: `${item.brand_id}`,
              brand_name: item.brand_name,
              module_id: 'select_module',
            })
          }}
        >
          <p className="brand-img-wrap">
            <Image
              className="brand-img"
              src={item.image_url || ''}
              lazy={true}
              alt={item?.brand_name}
              width={150}
              height={100}
            />
          </p>
          <p className="brand-name">{item.brand_name}</p>
        </a>
      </Link>
      <style jsx>
        {`
          .model {
            flex: 1;
            text-align: center;
            margin-top: -4px;
          }
          .brand-img-wrap {
            width: 40px;
            height: 40px;
            margin: 0 auto;
            border-radius: 50%;
          }
          .model:hover .brand-name {
            color: #e62021;
          }
          .brand-wrap {
            display: inline-block;
            width: 100%;
            text-align: center;
            height: 40px;
            transition: all 0.1s ease-in-out;
          }
          .brand-name {
            color: #1f2129;
            font-size: 12px;
            width: 100%;
          }
        `}
      </style>
    </div>
  )
}

export default function RenderHotBrand({
  hotBrand = [],
  responsiveType = 'xl',
}: {
  [key: string]: any
  responsiveType: string
}) {
  const [brandPage, setBrandPage] = useState(
    brandPageConfig[responsiveType]['page']
  )
  const [brandSize, setBrandSize] = useState(
    brandPageConfig[responsiveType]['size']
  )
  const [slideIndex, setSlideIndex] = useState(0)
  const [renderList, setRenderList] = useState([])

  useEffect(() => {
    setBrandPage(brandPageConfig[responsiveType]['page'])
    setBrandSize(brandPageConfig[responsiveType]['size'])
  }, [responsiveType])

  useEffect(() => {
    const currentIndex = slideIndex * brandSize
    let currectList = hotBrand.slice(currentIndex, currentIndex + brandSize)

    if (currentIndex + brandSize > hotBrand.length) {
      currectList = hotBrand.slice(-brandSize)
    }
    setRenderList(currectList)
  }, [brandSize, brandPage, slideIndex, hotBrand])
  return (
    <div className="brand-list-wrap">
      {hotBrand?.length && (
        <div className="brand-list">
          <div className="brand-title">
            <Link
              href={`/auto/library/x-x-x-x-x-x-x-x-x-x-x`}
              as={`/auto/library/x-x-x-x-x-x-x-x-x-x-x`}
            >
              <a
                target="_blank"
                className="g-active-link-text"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'select_module_left_nav',
                    button_name: '品牌',
                    module_id: 'select_module',
                  })
                }}
              >
                品牌
              </a>
            </Link>
          </div>
          <div className="box clearfix">
            <div className="list-item-wrap tw-grid tw-gap-12 tw-grid-cols-7 md:tw-grid-cols-9 xl:tw-grid-cols-13 2xl:tw-grid-cols-16">
              {renderList?.map((item: any, index: number) => {
                const name = item.brand_name

                return <>{renderBrandItem(item, index)}</>
              })}
            </div>
            <SwiperButton
              className={slideIndex <= 0 ? 'swiper-button-disabled' : ''}
              onClick={() => {
                setSlideIndex((prev) => {
                  if (prev <= 0) {
                    return 0
                  }
                  return prev - 1
                })
              }}
              theme="gray"
              type="prev"
              buttonStyle={{
                position: 'absolute',
                left: '4px',
                top: '7px',
                zIndex: 9,
              }}
            />
            <SwiperButton
              onClick={() => {
                setSlideIndex((prev) => {
                  if (prev >= brandPage) {
                    return brandPage
                  }
                  return prev + 1
                })
              }}
              theme="gray"
              type="next"
              buttonStyle={{
                position: 'absolute',
                right: '1px',
                top: '7px',
                zIndex: 9,
              }}
              className={classnames({
                'tw-hidden': slideIndex + 1 >= brandPage,
              })}
            />
            <span
              className={classnames({
                'cus-button-next-click': true,
                'tw-hidden': !(slideIndex + 1 >= brandPage),
              })}
            >
              <Link
                href={'/auto/library/x-x-x-x-x-x-x-x-x-x-x'}
                as={'/auto/library/x-x-x-x-x-x-x-x-x-x-x'}
              >
                <a
                  target="_blank"
                  className="g-active-link-text"
                  onClick={() => {
                    sendTeaCommEvent('clk_event', {
                      event_id: 'select_module_switch_btn',
                      module_id: 'select_module',
                    })
                  }}
                >
                  更多
                </a>
              </Link>
            </span>
          </div>
        </div>
      )}
      <style jsx>
        {`
          .brand-list {
            display: flex;
          }
          .brand-title {
            width: 45px;
            padding: 10px 0 0 0;
            font-size: 16px;
            color: #1f2129;
          }
          .box {
            flex: 1;
            overflow: hidden;
            height: 70px;
            position: relative;
          }
          .list-item-wrap {
            padding: 0 40px;
          }
        `}
      </style>
    </div>
  )
}
